import dayjs from 'dayjs'
import { req, withParams } from 'vuelidate/lib/validators/common'

export default (param) =>
  withParams({ type: 'dateFormat', param }, (value) => {
    return (
      !req(value) || dayjs(value, typeof param === 'function' ? param() : param, true).isValid()
    )
  })
